module.exports = __webpack_public_path__ + "static/media/live_wallpaper.5be1f290.mp4";